export const formFieldLabelClassName =
  "block text-sm font-semibold text-slate-700";

export const formControlClassName =
  "mt-1 block h-11 w-full rounded-control border border-strong bg-surface px-4 text-base font-normal text-foreground transition-colors focus-visible:outline-none placeholder:text-foreground-muted focus:border-focus disabled:cursor-not-allowed disabled:bg-surface-subtle disabled:opacity-60";

export const formTextareaClassName =
  "mt-1 w-full resize-none rounded-control border border-strong bg-surface px-4 py-3 text-base font-normal text-foreground transition-colors focus-visible:outline-none placeholder:text-foreground-muted focus:border-focus disabled:cursor-not-allowed disabled:bg-surface-subtle disabled:opacity-60";

export const requiredFieldLabelClassName =
  "after:ml-0.5 after:text-red-500 after:content-['*']";

export const primaryActionButtonClassName =
  "inline-flex min-h-11 items-center justify-center gap-2 rounded-control bg-brand px-4 py-2 text-sm font-semibold text-brand-foreground shadow-subtle transition-colors hover:bg-brand-dark focus:outline-none focus:ring-2 focus:ring-focus/30 disabled:cursor-not-allowed disabled:opacity-60";

export const secondaryActionButtonClassName =
  "inline-flex min-h-11 items-center justify-center gap-1.5 rounded-control border border-brand/40 bg-surface px-3 py-2 text-sm font-semibold text-brand-dark transition-colors hover:border-brand hover:bg-brand-soft focus:outline-none focus:ring-2 focus:ring-focus/30 disabled:cursor-not-allowed disabled:opacity-50";

export const neutralActionButtonClassName =
  "inline-flex min-h-11 items-center justify-center gap-1.5 rounded-control border border-strong bg-surface px-3 py-2 text-sm font-semibold text-foreground transition-colors hover:bg-surface-subtle focus:outline-none focus:ring-2 focus:ring-focus/30 disabled:cursor-not-allowed disabled:opacity-50";

export const textActionButtonClassName =
  "inline-flex min-h-11 items-center gap-1 text-sm font-bold text-brand-dark underline-offset-4 hover:underline focus:outline-none focus:ring-2 focus:ring-focus/30 disabled:cursor-not-allowed disabled:opacity-50";

/**
 * Cartão de formulário de página (ex.: Sugerir melhoria, Criar ordem
 * emergencial): centralizado na área de conteúdo, com largura máxima única,
 * bordas neutras e a cor de destaque reservada à ação principal.
 */
export const formCardClassName =
  "mx-auto w-full max-w-3xl rounded-card border border-border bg-surface p-4 shadow-subtle sm:p-6";

export const formCardHeaderClassName = "mb-5 border-b border-border pb-4";

export const formCardTitleClassName = "text-lg font-semibold text-foreground";

export const formCardDescriptionClassName = "mt-1 text-sm text-foreground-muted";

export const formCardFooterClassName =
  "mt-6 flex flex-col-reverse gap-2 border-t border-border pt-4 sm:flex-row sm:justify-end";

export const filterControlClassName =
  "data-[active=true]:border-emerald-600 data-[active=true]:bg-emerald-50 block h-11 w-full rounded-control border border-strong bg-surface px-3 text-sm font-normal text-foreground transition-colors focus-visible:outline-none placeholder:text-foreground-muted focus:border-focus disabled:cursor-not-allowed disabled:bg-surface-subtle disabled:opacity-60";
